const { send: ajax } = require('client/lib/request')

let cachedContacts

const API = {

  contacts: function () {
    if (!isUserLoggedIn()) {
      return Promise.resolve([])
    }
    if (cachedContacts) {
      return Promise.resolve(cachedContacts)
    }
    return ajax({
      url: '/api/v0.1/user/contacts',
      method: 'post'
    })
    .then(response => cachedContacts = response)
    .catch(() => [])
  },

  supersearch: function () {
    if (!isUserLoggedIn()) {
      return Promise.resolve([])
    }
    return ajax({
      url: '/api/v0.1/user/supersearch',
      method: 'post'
    })
    .catch(() => [])
  }

}

function isUserLoggedIn() {
  // Client V1 compatibility
  if (typeof wiggin === 'object') {
    return wiggin.user.loggedIn
  }
  // Client V2 compatibility
  if (typeof app === 'object' && app.store) {
    return app.store.getState().user.loggedIn
  }
}

module.exports = { API }
